import {NavLink} from "react-router-dom";
import {IconContext} from "react-icons";
import {FaArrowCircleLeft} from "react-icons/fa";
import {AiFillPicture} from "react-icons/ai";
import {FaPhotoVideo} from "react-icons/fa";
import { LuScissorsSquareDashedBottom } from "react-icons/lu";
export const Forfait = () => {
  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
      {/* Navigation */}
      <div className="fixed top-5 left-5 z-50">
        <IconContext.Provider value={{ size: "2em", className: "text-white hover:text-gray-400 transition-colors" }}>
          <NavLink to={'/'}>
            <FaArrowCircleLeft />
          </NavLink>
        </IconContext.Provider>
      </div>
      
      {/* Titre de la page en haut */}
      <div className="pt-12 pb-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight">FOR<span className="text-gray-400">FAITS</span></h1>
        <div className="w-24 h-1 bg-white mx-auto mt-4 mb-8"></div>
      </div>

      {/* Hero Section */}
      <section className="relative py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-center mb-6 tracking-tight">
            Forfaits
          </h1>
          <p className="text-xl text-gray-300 text-center max-w-3xl mx-auto mb-16">
            Découvrez nos offres personnalisées pour immortaliser vos moments précieux
          </p>
        </div>
      </section>

      {/* Services Sections */}
      <div className="max-w-7xl mx-auto px-4 pb-24">
        {/* Photography Section */}
        <section className="mb-24">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Photographie
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Personal Photography */}
            <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-gray-800">
              <div className="flex flex-col items-center">
                <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                  <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                    <AiFillPicture />
                  </IconContext.Provider>
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white">Séance Personnelle</h3>
                <p className="text-3xl font-bold text-white mb-4">150$</p>
                <p className="text-sm text-gray-500 mb-2">Par session</p>
                <p className="text-gray-400 text-center mt-4">
                  Un service photo personnalisé, capturant vos moments uniques avec professionnalisme
                </p>
              </div>
            </div>

            {/* Corporate Photography */}
            <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-gray-800">
              <div className="flex flex-col items-center">
                <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                  <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                    <AiFillPicture />
                  </IconContext.Provider>
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white">Photos Corporatives</h3>
                <p className="text-3xl font-bold text-white mb-4">50$</p>
                <p className="text-sm text-gray-500 mb-2">Par employé</p>
                <p className="text-gray-400 text-center mt-4">
                  Photos professionnelles pour votre équipe et vos employés
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Videography Section */}
        <section className="mb-24">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Vidéographie
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Half Day Video */}
            <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-gray-800">
              <div className="flex flex-col items-center">
                <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                  <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                    <FaPhotoVideo />
                  </IconContext.Provider>
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white">Demi-Journée</h3>
                <p className="text-3xl font-bold text-white mb-4">À partir de 250$</p>
                <p className="text-sm text-gray-500 mb-2">5 heures et moins</p>
                <p className="text-gray-400 text-center mt-4">
                  Vidéos professionnelles sur mesure, idéales pour les événements courts
                </p>
              </div>
            </div>

            {/* Full Day Video */}
            <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-gray-800">
              <div className="flex flex-col items-center">
                <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                  <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                    <FaPhotoVideo />
                  </IconContext.Provider>
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white">Journée Complète</h3>
                <p className="text-3xl font-bold text-white mb-4">À partir de 500$</p>
                <p className="text-sm text-gray-500 mb-2">5 heures et plus</p>
                <p className="text-gray-400 text-center mt-4">
                  Couverture vidéo complète, parfaite pour les mariages et grands événements
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Editing Section */}
        <section className="mb-24">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Montage Vidéo
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Half Day Editing */}
            <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-gray-800">
              <div className="flex flex-col items-center">
                <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                  <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                    <LuScissorsSquareDashedBottom />
                  </IconContext.Provider>
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white">Montage Simple</h3>
                <p className="text-3xl font-bold text-white mb-4">À partir de 150$</p>
                <p className="text-gray-400 text-center mt-4">
                  Montage vidéo professionnel et créatif pour vos projets courts
                </p>
              </div>
            </div>

            {/* Full Day Editing */}
            <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-gray-800">
              <div className="flex flex-col items-center">
                <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                  <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                    <LuScissorsSquareDashedBottom />
                  </IconContext.Provider>
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white">Montage Complet</h3>
                <p className="text-3xl font-bold text-white mb-4">À partir de 250$</p>
                <p className="text-gray-400 text-center mt-4">
                  Montage vidéo élaboré pour vos projets d'envergure
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <h3 className="text-2xl md:text-3xl font-semibold mb-4 text-white">
            Besoin de plus d'informations ?
          </h3>
          <p className="text-gray-400 mb-8">
            Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé
          </p>
          <NavLink 
            to="/Contact"
            className="inline-block bg-[#16161e] text-white px-8 py-3 rounded-lg hover:bg-gray-700 border border-gray-700 transition-colors"
          >
            Nous Contacter
          </NavLink>
        </div>
      </div>
    </main>
  );
};
